import React from "react";
import QASection from "../QASection";

const QuestionAnswerStep = ({ ctx }) => {
  const { errors, formData, locale, questions, setFormData } = ctx;
  return <>
                <QASection errors={errors} data={questions ? questions : []} centerId={formData?.center_id} admissionId={formData?.admission_id} qaAnswers={formData?.qaAnswers} setFormData={setFormData} locale={locale} />
              </>;
};

export default QuestionAnswerStep;
